( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '.memberships-callout__marquee' ).forEach( function( marquee ) {
        const track = marquee.querySelector( '.memberships-callout__marquee__track' );
        const originalSet = track ? track.querySelector( '.memberships-callout__marquee__set' ) : null;

        if ( !track || !originalSet ) {
          return;
        }

        const fillTrack = function() {
          track.querySelectorAll( '[data-marquee-copy]' ).forEach( function( copy ) {
            copy.remove();
          } );

          const setWidth = originalSet.getBoundingClientRect().width;

          if ( !setWidth ) {
            return;
          }

          track.style.setProperty( '--memberships-marquee-set-width', `${setWidth}px` );

          const copiesNeeded = Math.max( 1, Math.ceil( marquee.clientWidth / setWidth ) );
          for ( let index = 0; index < copiesNeeded; index++ ) {
            const copy = originalSet.cloneNode( true );
            copy.setAttribute( 'aria-hidden', 'true' );
            copy.setAttribute( 'data-marquee-copy', '' );
            track.appendChild( copy );
          }
        };

        fillTrack();

        if ( 'ResizeObserver' in window ) {
          const observer = new ResizeObserver( fillTrack );
          observer.observe( marquee );
        } else {
          window.addEventListener( 'resize', fillTrack );
        }

        if ( document.fonts ) {
          document.fonts.ready.then( fillTrack );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'memberships-callout', COMPONENT );
} )( app );
